<template>
	<div class="net-income-card">
		<el-card class="box-card" style="margin-bottom: 30px;" v-if="current_customer">
			<div slot="header" class="row d-flex align-items-center">
				<b-col cols="6">
					<h3 class="mb-0">Net Income</h3>
				</b-col>
				<b-col v-if="!current_customer.cjp_id">
					<el-button @click="$refs.drawer_net_income.viewDetails()" class="float-right py-0 text-primary"
						type="text">Edit</el-button>
				</b-col>
				<b-col v-else>
					<el-button @click="$refs.customerJointNetIncomeModal.toggleView()" class="float-right py-0 text-primary"
						type="text">View Details</el-button>
				</b-col>
			</div>
			<div>
				<div v-if="!current_customer.cjp_id">
					<div class="mb-2">
						<span class="text-primary total-net-income">{{ getNetIncome(current_customer) }}</span>
						<b-badge pill variant="dark" class="text-white text-capitalize mx-3"
							v-if="current_customer.incomes.main.type">{{ current_customer.incomes.main.type }}</b-badge>
					</div>
					<div class="mb-2" v-if="getIncomeType(current_customer)">
						<span class="text-primary income-type">{{ getIncomeType(current_customer) }}</span>
					</div>
					<div v-if="current_customer.incomes.variable.length > 0" class="d-flex align-items-center">
						<b-icon icon="check-lg" variant="success" class="mr-2"></b-icon>
						<span>Variable Income</span>
					</div>
				</div>
				<div v-else>
					<h4 class="mb-0">Total Joint Net Income</h4>
					<!-- <h3 class="text-primary">RM{{ current_customer.incomes.main.net_income | moneyFormatter }}</h3> -->
					<h3 class="text-primary">RM{{ current_customer.customer_joint_profiles.reduce((total, item) => 
						total + parseFloat(item.main_income.net_income ? item.main_income.net_income : 0), 0)
						| moneyFormatter 
					}}</h3>
					<hr class="my-3">
					<h4 class="badge bg-fintos">Individual</h4>
					<div v-for="(joint_profile, index) in current_customer.customer_joint_profiles" :key="index" class="mb-2">
						<h4 class="mb-0">{{ joint_profile.name }}</h4>
						<!-- <h3 class="text-primary">RM{{ joint_profile.main_income.net_income | moneyFormatter }}</h3> -->
						<h3 class="text-primary">{{ getNetIncome(joint_profile) }}</h3>
					</div>
				</div>
			</div>
		</el-card>

		<!-- Drawer for Net Income Details -->
		<drawer-view-net-income-details ref="drawer_net_income"></drawer-view-net-income-details>
		<CustomerJointNetIncomeModal ref="customerJointNetIncomeModal" :customer="current_customer" />
	</div>
</template>
<script>
import { Card, Button } from 'element-ui'
import DrawerViewNetIncomeDetails from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerNetIncome/DrawerNetIncome'
import { mapState } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { useLookupStore } from '@/stores/lookupStore'
import CustomerJointNetIncomeModal from '@/views/CustomerProfile/CustomerProfileDetails/LeftProfileDetails/Modal/CustomerJointNetIncomeModal'
import { COUNTRIES_CURRENCY } from '@/assets/js/options.js'

export default {
	name: 'net-income',
	components: {
		CustomerJointNetIncomeModal,
		DrawerViewNetIncomeDetails,
		[Card.name]: Card,
		[Button.name]: Button,
	},
	data() {
		return {
			countries: COUNTRIES_CURRENCY,
		}
	},
	computed: {
		...mapState(useCustomerStore, ['current_customer']),
		totalNetIncomeSGD() {
			let payslip_other_deduction = this.getPaySlipOtherDeduction();
			let currency = this.getCurrency();
			payslip_other_deduction = _gHlp.currencyFromRM(
				payslip_other_deduction,
				currency
			);
			const gross_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.current_customer, 'incomes.main.gross_income', 0),
				currency
			);
			const bonus_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.current_customer, 'incomes.main.av_bonus_inc', 0),
				currency
			);
			const rental_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.current_customer, 'incomes.main.total_rental_inc', 0),
				currency
			);
			const other_income = _gHlp.currencyFromRM(
				_gHlp.getValue(this.current_customer, 'incomes.main.total_other_inc', 0),
				this.getCurrency()
			);
			const socso = _gHlp.getValue(this.current_customer, 'incomes.main.sosco', 0);
			const epf = _gHlp.getValue(this.current_customer, 'incomes.main.epf', 0);
			const incomeTax = _gHlp.getValue(this.current_customer, 'incomes.main.income_tax', 0);
			if (!this.isForeigIncome) {
				const net_income = _gHlp.getValue(this.current_customer, 'incomes.main.net_income', 0);
				const total = parseFloat(net_income) + parseFloat(socso) + parseFloat(epf) + parseFloat(incomeTax);
				return parseFloat(total.toFixed(2));
			}
			const total = this.checkNum(gross_income) - this.checkNum(payslip_other_deduction) +
				this.checkNum(rental_income) + this.checkNum(other_income) + this.checkNum(bonus_income);
			return parseFloat(total.toFixed(2));
		},
		totalNetIncomeRYM() {
			let payslip_other_deduction = this.getPaySlipOtherDeduction();
			const gross_income = _gHlp.getValue(this.current_customer, 'incomes.main.gross_income', 0);
			const bonus_income = _gHlp.getValue(this.current_customer, 'incomes.main.av_bonus_inc', 0);
			const rental_income = _gHlp.getValue(this.current_customer, 'incomes.main.total_rental_inc', 0);
			const other_income = _gHlp.getValue(this.current_customer, 'incomes.main.total_other_inc', 0);
			const total = parseFloat(gross_income) - payslip_other_deduction + parseFloat(rental_income) + parseFloat(other_income) + parseFloat(bonus_income);
			parseFloat(total.toFixed(2))
			return parseFloat(total.toFixed(2));
		},
		isForeigIncome() {
			const working_country = _gHlp.getValue(this.current_customer, 'incomes.main.working_country', 'Malaysia')
			const is_foreigner = !_gHlp.isEmpty(working_country) && (working_country != 'Malaysia')
			return is_foreigner
		},
	},
	methods: {
		checkNum(value) {
			const num = parseFloat(value);
			return Number.isFinite(num) ? num : 0.00;
		},
		getNetIncome(customer) {
			const working_country = _gHlp.getValue(customer, 'incomes.main.working_country', 'Malaysia')
			const ctry = this.countries.find(o => o.name == working_country)
			const curency = _gHlp.getValue(ctry, 'currency', 'MYR');
			const is_foreigner = !_gHlp.isEmpty(working_country) && (working_country != 'Malaysia')

			if (is_foreigner) {
				return this.showSGD();
			} else {
				return "RM" + parseFloat(_gHlp.getValue(customer, 'incomes.main.net_income', 0)).toLocaleString(undefined, { minimumFractionDigits: 2 })
			}
		},
		getIncomeType(customer) {
			const income_type = _gHlp.getValue(customer, 'incomes.main.income_type_id', null)
			const income_type_name = useLookupStore().list_income_type.find((item) => (item.income_type_id == income_type));
			return income_type_name?.name || ''
		},
		showSGD() {
			const sgd = this.moneyFormatter(this.totalNetIncomeSGD);
			const rym = this.moneyFormatter(this.totalNetIncomeRYM);
			return `SGD ${sgd} / RM ${rym}`;
		},
		moneyFormatter(value) {
			return parseFloat(value).toLocaleString(undefined, {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		},
		getPaySlipOtherDeduction() {
			let payslip_other_deduction = 0;
			const oth = _gHlp.getValue(this.current_customer, 'incomes.main.total_other_deduction', 0);
			const ndi = _gHlp.getValue(this.current_customer, 'incomes.main.ndi_deduction', 0);
			const tax = _gHlp.getValue(this.current_customer, 'incomes.main.tax_deduction', 0);
			if (!this.isForeigIncome) {
				payslip_other_deduction = oth;
			} else {
				payslip_other_deduction = parseFloat(oth) + parseFloat(ndi) + parseFloat(tax);
			}
			return payslip_other_deduction;
		},
		getCurrency() {
			let currency = _gHlp.getValue(this.current_customer, 'incomes.main.foreign_currency', 0)
			return currency;
		}
	}
}
</script>